import HttpRequest from "@/services/http_request";

class MasterDataProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getFaculty(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const res = await this.get(
      `reg/master/Faculty?facultyid=0&lang=${this.variableParser(payload.lang)}`
    );
    const { data } = res.data;
    return data;
  }

  async getDepartment(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const res = await this.get(
      `reg/master/Department?facultyid=${this.variableParser(
        payload.facultyid,
        0
      )}&departmentid=0&lang=${this.variableParser(payload.lang)}`
    );
    const { data } = res.data;
    return data;
  }

  async getLevel(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const res = await this.get(
      `reg/master/Level?levelid=0&lang=${this.variableParser(payload.lang)}`
    );
    const { data } = res.data;
    return data;
  }

  async getClassType(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`,
      lang: this.variableParser(payload.lang)
    });
    const res = await this.get("reg/time/classtype");
    const { data } = res.data;
    return data;
  }
  async getClassTypeForClassAdjustResult(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`,
      lang: this.variableParser(payload.lang)
    });
    const res = await this.get("reg/enroll/coordinator/getclasstype");
    const { data } = res.data;
    return data;
  }
  async getStudentStatus(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const req = {
      lang: this.variableParser(payload.lang)
    };
    const res = await this.get("reg/enroll/studentstatus", req);
    const { data } = res.data;
    return data;
  }

  async getAcadyear(token) {
    this.setHeaderBearerAuth(token);
    const res = await this.get("reg/enroll/acadyear");
    const { data } = res.data;
    return data;
  }

  async getSemester(token) {
    this.setHeaderBearerAuth(token);
    const res = await this.get("reg/enroll/semester");
    const { data } = res.data;
    return data;
  }

  async getCurrentIP() {
    this.setHeader({});
    const res = await this.get(process.env.VUE_APP_API_GETIP);
    return res.data;
  }

  async getMenu(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`,
      user_id: this.variableParser(payload.userId),
      lang: this.variableParser(payload.lang)
    });
    const res = await this.get("reg/enroll/menu");
    const { data } = res.data;
    return data;
  }

  async getSection(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      coursecode: this.variableParser(request.coursecode),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/enroll/section");
    const { data } = res.data;
    return data;
  }
  async getStudentStatusChkList(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`,
      lang: this.variableParser(payload.lang)
    })
    const res = await this.get("reg/enroll/staff/getstatusmaintain");
    const { data } = res.data;
    return data;
  }
  async getPeriod(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const req = {
      lang: this.variableParser(payload.lang)
    };
    const res = await this.get("reg/enroll/coordinator/getperiod", req);
    const { data } = res.data;
    return data;
  }
  async getExamCode(payload) {
    this.setHeaderBearerAuth(this.variableParser(payload.token));
    const req = {
      lang: this.variableParser(payload.lang)
    };
    const res = await this.get("reg/enroll/report/getexamcode", req);
    const { data } = res.data;
    return data;
  }
}

export default MasterDataProvider;
